// extracted by mini-css-extract-plugin
module.exports = {"btn-line":"btn-line--2Q7J7","order-num":"order-num--3Qp8G","number-input":"number-input--2XKLW","delete-btn":"delete-btn--33ooB"};